import ListIcon from "@redotech/redo-icons/list.svg";
import { ExistsFilterOperator } from "@redotech/redo-model/views/advanced-filters/exists-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.pickSessionId;

export const PickSessionExistsFilter: AdvancedTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: true,
    operator: ExistsFilterOperator.NOT_EXISTS,
  },
  Icon: ListIcon,
  boolDisplay: { falseDisplay: "not assigned", trueDisplay: "assigned" },
  displayName: entry.displayName,
};
